/*  */

//*componentes-utiles
//*datos

//*clases

//*componente
    export default function PaginaMenu4() {
    return (
        <div className="container container-Vista" >
        <h1>Página menu 4</h1>
        <br></br>
        </div>
    );
    }
